export const StatusEnum = {
  PENDING: 0,
  SUCCESS: 1,
  ERROR: 2,
};
